import SchoolIcon from "@material-ui/icons/School";
import { useState } from "react";
import InfoWindow from "./InfoWindow";
import unselectedMarker from "assets/images/unselected-marker.png";

interface IMarker {
  lat: number;
  lng: number;
  resource: object;
  isSchool?: boolean;
}

const Marker = ({ resource, isSchool }: IMarker) => {
  const [isOpenInfoWindow, setIsOpenInfoWindow] = useState<boolean>(false);

  return (
    <div
      style={{
        position: "absolute",
        top: "-30px",
        left: "-17px",
        cursor: "pointer",
      }}
      onClick={() => setIsOpenInfoWindow((value) => !value)}
    >
      {isSchool ? (
        <SchoolIcon
          fontSize="large"
          style={{
            fill: "#2F4DB9",
          }}
        />
      ) : (
        <img src={unselectedMarker} alt="" />
      )}

      {isOpenInfoWindow && <InfoWindow isSchool={isSchool} data={resource} />}
    </div>
  );
};

export default Marker;
